import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {Route, Switch} from 'react-router-dom';

import ProjectController from "Controllers/ProjectController";
import * as ProjectSelectors from "Data/projects/ProjectSelectors";

class ProjectRoute extends React.Component
{
    state = {
        loading: true
    };

    static propTypes = {
        loading: PropTypes.bool.isRequired,
    };

    componentDidMount()
    {
        // do any extra fetching here
        // see <StoryRoute /> for example

        this.setState({loading: false});
    }

    render()
    {
        const loading = this.props.loading || this.state.loading;

        if (! this.props.project) {
            // could still be loading??
            return null;
        }

        return <Switch>
            <Route exact path="/projects/:projectId">
                <ProjectController
                    loading={loading}
                    project={this.props.project}
                />
            </Route>
            <Route exact path="/projects/:projectId/:storyId">
                {
                    props => <ProjectController
                        loading={loading}
                        project={this.props.project}
                        storyId={props.match.params.storyId}
                    />
                }
            </Route>
        </Switch>;
    }
}

const mapStateToProps = (state, ownProps) => ({
    project: ProjectSelectors.getProjectById(state, ownProps.match.params.projectId),
});

const mapDispatchToProps = {

};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectRoute);